module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/sorority-mobile-8344b87ce1f5766d3e30b1f26473093b.jpg";